import { render, staticRenderFns } from "./MainDaily.vue?vue&type=template&id=6504048a&scoped=true"
import script from "./MainDaily.vue?vue&type=script&lang=js"
export * from "./MainDaily.vue?vue&type=script&lang=js"
import style0 from "./MainDaily.vue?vue&type=style&index=0&id=6504048a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6504048a",
  null
  
)

export default component.exports